// extracted by mini-css-extract-plugin
export default {"component":"Gta2L","icon":"KwK5O"};